import { dataIntelligenceSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIntelligenceSolid = /*#__PURE__*/createIcon(dataIntelligenceSolid)
export default IconIntelligenceSolid
